import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/pricing-your-products/global'

export const PRICING_YOUR_PRODUCTS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
